import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
import Logo from './Logo';

const COLS = [
  {
    title: 'Shop',
    links: [
      ['All Parts', '/shop'],
      ['Engine Parts', '/shop?category=engine-parts'],
      ['Filters & Maintenance', '/shop?category=filters-maintenance'],
      ['Hydraulic Parts', '/shop?category=hydraulic-parts'],
      ['Electrical Components', '/shop?category=electrical-components'],
      ['Implements & Accessories', '/shop?category=implements-accessories'],
    ],
  },
  {
    title: 'Tractor Brands',
    links: [
      ['John Deere Parts', '/shop?brand=John+Deere'],
      ['Kubota Parts', '/shop?brand=Kubota'],
      ['New Holland Parts', '/shop?brand=New+Holland'],
      ['Massey Ferguson Parts', '/shop?brand=Massey+Ferguson'],
      ['Case IH Parts', '/shop?brand=Case+IH'],
      ['Mahindra Parts', '/shop?brand=Mahindra'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About Us', '/about'],
      ['Contact Us', '/contact'],
      ['Find Parts for My Tractor', '/find-parts'],
      ['Cart', '/cart'],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-charcoal text-cream/70 noise relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Logo />
            <p className="mt-5 text-sm leading-relaxed max-w-sm">
              Dependable tractor parts and agricultural equipment components at competitive prices —
              shipped fast to farms, repair shops and dealers across the United States.
            </p>
            <div className="mt-6 space-y-2.5 text-sm">
              <p className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-flame" /> 1-800-TRACTOR (24/7 Parts Desk)
              </p>
              <p className="flex items-center gap-2.5">
                <Mail className="w-4 h-4 text-flame" /> parts@tractorpartsusa.com
              </p>
              <p className="flex items-center gap-2.5">
                <MapPin className="w-4 h-4 text-flame" /> Des Moines, Iowa — United States
              </p>
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-display font-semibold uppercase tracking-wide text-cream text-sm mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5 text-sm">
                {col.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="hover:text-flame transition-colors group inline-flex items-center gap-1">
                      {label}
                      <ArrowRight className="w-3 h-3 opacity-0 -ml-1 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-cream/40">
          <p>© {new Date().getFullYear()} TractorParts USA. All rights reserved.</p>
          <p className="max-w-xl">
            TractorParts USA is an independent parts supplier. We are not affiliated with, sponsored or
            authorized by any equipment manufacturer. All brand names are trademarks of their respective owners.
          </p>
        </div>
      </div>
    </footer>
  );
}
